/*
 * @Descripttion: 
 * @version: 
 * @Author: jinfjk
 * @Date: 2020-08-17 09:56:43
 * @LastEditors: bbq
 * @LastEditTime: 2020-08-27 14:06:59
 */
import FormWithAutoFocus from './FormWithAutoFocus';
import TableWithAutoFocus from './TableWithAutoFocus';
import executeAutoFocus from './executeAutoFocus';
import SearchWithAutoFocus from './SearchWithAutoFocus';

export default {
    FormWithAutoFocus,
    TableWithAutoFocus,
    executeAutoFocus,
    SearchWithAutoFocus,
};